import api from 'api';

export function backfillEmbeddings(entityType, entityId) {
    return api.post('embeddings/backfill', { entityType, ...(entityId ? { entityId } : {}) });
}
